import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../App.css';
import Main from '../App';
import { useEffect, useState } from 'react';
import Modal from './components/Modal';
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from 'primereact/api';
import { createRole, deleteRole, fetchRole, updateRole, detailRole } from '../slice/roleSlice';
import { fetchPermission, assignPermission } from '../slice/permissionSlice';
import { useDispatch, useSelector } from 'react-redux';
import { InputSearch } from './components/TextField'
import { Skeleton } from 'primereact/skeleton';

function RolePermission(){
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        }
    });
    const dispatch = useDispatch();
    const {roles = [], isLoading, error } = useSelector((state) => state.roles);
    const { permissions = [] } = useSelector((state) => state.permissions || {});
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const openAddModal = () => {
        setName('');
        setIsAddModalOpen(true)
    };
    const closeAddModal = () => setIsAddModalOpen(false);
    const closeEditModal = () => setIsEditModalOpen(false);
    const [isButtonClick, setIsButtonClick] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');     

    const openEditModal = (data) => {
        setModalLoading(true);
        
        dispatch(detailRole(data.id))
        .unwrap()
        .then((response) => {
            if (response.success) {
                setRolePermission(response.data.permissions);
            }
            setModalLoading(false);
        }).catch((err) => {
            setModalLoading(false);
            Toast.fire({
                icon: "Error",
                title: err
            });
        })
        setName(data.name);
        setSelectedData(data); 
        setIsEditModalOpen(true);
    };

    const [name, setName] = useState('');
    const [selectedData, setSelectedData] = useState(null);
    const [rolePermission, setRolePermission] = useState([]);   
          
    const [ids, setIds] = useState([]);

    useEffect(() => {
        dispatch(fetchRole());
        dispatch(fetchPermission());
    },[dispatch]);
    
    const handleCheckboxChange = (perm) => {
        setRolePermission((prevRoleIds) => {
            let updatedRolePermissions;
            if (prevRoleIds.some((rolePerm) => rolePerm.id === perm.id)) {
                updatedRolePermissions = prevRoleIds.filter((rolePerm) => rolePerm.id !== perm.id);
            } else {
                updatedRolePermissions = [...prevRoleIds, perm];
            }
    
            setIds(updatedRolePermissions.map((rolePerm) => rolePerm.id));
            return updatedRolePermissions;
        });
    };

    const handleStore = async (e) => {
        e.preventDefault();
        setIsButtonClick(true);
        const credentials = { name: name };
        
        dispatch(createRole(credentials))
        .unwrap() 
        .then((response) => {
            setIsButtonClick(false);
            setIsAddModalOpen(false);
            Swal.fire("Success", response.message, "success");
        })
        .catch((err) => {
            setIsButtonClick(false);
            setIsAddModalOpen(false);
            Swal.fire("Error", err, "error");
        });
    }

    const handleAssign = async (e) => {
        e.preventDefault();
        setIsButtonClick(true);
        const credentialsAssign = { ids: ids, id : selectedData.id, };

        dispatch(assignPermission(credentialsAssign))
        .unwrap() 
        .then((response) => {   
            const credentialsUpdate = { id: selectedData.id, name : name };
            dispatch(updateRole(credentialsUpdate))
            if(response.success){
                Swal.fire("Success", response.message, "success");
            }    
            setIsButtonClick(false); 
            setIsEditModalOpen(false);    
        })
        .catch((err) => {
            setIsButtonClick(false);
            setIsEditModalOpen(false);
            Swal.fire("Failed", err, "error");
        });
    };

    const handleDelete = async (id) => {
        const confirmed = await Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this role? This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            allowOutsideClick: false,
            preConfirm: () => {
                return dispatch(deleteRole(id))
                .unwrap() 
                .then((response) => {
                    Swal.fire("Success", response.message, "success");
                })
                .catch((err) => {
                    console.error('Delete failed:', err);
                    Swal.fire("Failed", err, "error");
                });
            },
        });
    
        if (!confirmed.isConfirmed) {
            return;
        } 
    };

    // Prime Datatable
    const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    
    const _filters = {
        ...filters,
        global: { ...(filters?.global || {}), value },
    };
    
    setFilters(_filters);
        setGlobalFilterValue(value);
    };
    
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        setGlobalFilterValue("");
    };
    
    useEffect(() => {
        initFilters();
    }, []);

    const renderHeader = () => {
        return (
            <div className="row my-3">
                <div className='col-md-4'>
                {roles.length <= 0 ? (
                    <Skeleton width='100%' height='3rem' borderRadius='10px'/>
                ):(
                    <InputSearch iconLeft="bi bi-search" name="searchInput" type="text" placeholder="Search" style={{ borderColor: "#ccc" }} value={globalFilterValue} onChange={onGlobalFilterChange} />
                )}
                </div>
            </div>
        );
    };

    const header = renderHeader();

    return (
       <Main>
            <div className='row my-3'>
                <div className='col-md-6'>
                    <h5 className='fw-semibold'>Role Permission</h5>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Role Permission</li>
                        </ol>
                    </nav>
                </div>
                <div className='col-md-5 d-flex justify-content-end'>
                    <div>
                        {roles.length <= 0 ? (
                            <Skeleton width='100px' height='2.5rem' borderRadius='10px'/>
                        ):(
                            <button className="btn btn-dark" onClick={openAddModal}>
                                Add New
                            </button>
                        )}

                        <Modal isOpen={isAddModalOpen} onClose={closeAddModal} title={'Add Role'} modalId={'addRoleModal'}>
                            <form onSubmit={handleStore}>
                                <div className="row my-3">
                                    <div className="col-md-6">
                                        <label>Name</label>
                                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control" placeholder='Enter Name'/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-dark" disabled={isButtonClick}>{isButtonClick ? 'Saving...' : 'Confirm'}</button>
                                    </div>
                                </div>
                            </form>
                        </Modal>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-11'>
                    <div className='card'>
                        <div className='card-body'>
                            {header}

                            <div className='row'>
                                <div className='col-md-12'>
                                    {roles.length <= 0 ? (
                                        <Skeleton width='100%' height='20rem' borderRadius='10px'/>
                                    ):(
                                        <DataTable value={roles} paginator showGridlines rows={10} dataKey="id" filters={filters} globalFilterFields={['name']} emptyMessage="No role found." onFilter={(e) => setFilters(e.filters)}>
                                            <Column header="No"  body={(rowData, { rowIndex }) => (isLoading ? <Skeleton/> : (rowIndex + 1))} />
                                            <Column field="name" header="Name" body={(rowData) =>(isLoading ? <Skeleton/> : (rowData.name))} />
                                            <Column header="Action" body={(rowData) => (isLoading ? <Skeleton/> : (
                                                <div className="d-flex gap-2">
                                                    <button className="btn btn-sm btn-outline-success" onClick={() => openEditModal(rowData)}>
                                                        <i className="bi bi-pencil"></i>
                                                    </button>
                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(rowData.id)}>
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                                ))} />
                                        </DataTable>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={isEditModalOpen} onClose={closeEditModal} title={'Edit Role'} modalId={'editRoleModal'}>
                    {selectedData && (
                        <>
                            <form onSubmit={handleAssign}>
                                <div className="row my-3">
                                    <div className="col-md-6">
                                        {modalLoading ? (
                                            <Skeleton width='100%' height='3rem' borderRadius='10px'/>
                                        ):(
                                            <>
                                                <label>Name</label>
                                                <input type="text" value={name} className="form-control" onInput={(e) => setName(e.target.value)} />
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className="row my-3">
                                    <div className="col-md-12" style={{ height: '300px', overflow: 'auto' }}>
                                        {modalLoading ? (
                                            <Skeleton width='100%' height='18rem' borderRadius='10px'/>
                                        ): (
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <td style={{ width: '10%' }}></td>
                                                        <td style={{ width: '90%' }}>Menu Name</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {permissions.map((perm, index) => {  
                                                        if (!perm || !perm.id) return null;                                                  
                                                        const isChecked = rolePermission.some((rolePerm) => rolePerm.id === perm.id);
                                                        return (
                                                            <tr key={index}>
                                                                <td className="d-flex justify-content-center align-items-center">
                                                                    <input 
                                                                        id={`permission-${perm.id}`}
                                                                        className="form-check-input mt-0"
                                                                        type="checkbox"
                                                                        value={perm.id}
                                                                        checked={isChecked}
                                                                        onChange={() => handleCheckboxChange(perm)}
                                                                    />
                                                                </td>
                                                                <td><label htmlFor={`permission-${perm.id}`}>{perm.name}</label></td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                                <div className="row justify-content-end">
                                    <div className="col-md-4 d-flex justify-content-end">
                                        {modalLoading ? (
                                            <Skeleton width="100px" height="40px" borderRadius="10px"></Skeleton>
                                        ):(
                                            <button type="submit" className="btn btn-dark" disabled={isButtonClick}>{isButtonClick ? 'Saving...' : 'Confirm'}</button>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </>
                    )}
                </Modal>
            </div>
       </Main>
    );
}

export default RolePermission;